import { ContentSyncCoordinator, type ContentSyncConfig } from "./content-sync";
import { tradeAlerts } from "@/plugins/LocalForagePlugin";
import { tradeAlertsSyncKey } from "@/types/products/product-keys";
import type { ContentfulTradeAlert, NormalizedContent } from "@tmi/types/entities";
import type { TradeAlerts } from "@tmi/types/api/content-models";

import { consoleLoggerFactory, getDefaultLoggerOptions, LogLevels } from "@/types/console-logger";
const logger = consoleLoggerFactory.create( getDefaultLoggerOptions( LogLevels.DEBUG ) );

const config: ContentSyncConfig<TradeAlerts, ContentfulTradeAlert> = {
    name: 'trade-alerts',
    store: tradeAlerts,
    syncKey: tradeAlertsSyncKey,
    metaQueryId: 'cbd5256ca0dcc0879c5601c9aaa8e0bd',
    contentQueryId: '210dba7500d8d488244bae6c7abe7efc',
    contentPageSize: 500,
    metaContentFilter: { fromPublishedDateTimeUTC: '2008-01-01' },
    extractMetaPayload: ( data ) => data.tradeAlertCatalog?.trade_alerts,
    extractContentPayload: ( data ) => data.tradeAlertCatalog?.trade_alerts,
    normalizeItem: normalizeTradeAlert
};

export class TradeAlertsSyncCoordinator {
    readonly #inner: ContentSyncCoordinator<TradeAlerts, ContentfulTradeAlert>;
    constructor() {
        this.#inner = new ContentSyncCoordinator( config );
    }
    patchRepository( authToken: string ): Promise<number> {
        return this.#inner.patchRepository( authToken );
    }
}

export function normalizeTradeAlert( alert: ContentfulTradeAlert ): NormalizedContent | undefined {
    try {
        return {
            contentfulId: alert.id,
            slug: alert.slug,
            publishedDate: alert.published_date,
            updatedDate: alert.publish_at,
            title: alert.title,
            text: alert.body,
            body2: alert.body2,
            videoLink: alert.video_link,
            isFeatured: alert.is_featured,
            preview: alert.preview,
            thumbnail: alert.thumbnail,
            editorialAd: alert.editorial_ad ?? undefined,
            authorId: alert.author_id,
            adProductId: alert.ad_product_id,
            categoryIds: alert.assoc_category_ids ?? [],
            industrySectorIds: alert.assoc_ind_sector_ids ?? [],
            productIds: alert.assoc_product_ids ?? [],
            sectorIds: alert.assoc_sector_ids ?? [],
            tagIds: alert.assoc_tag_ids ?? [],
            tickerIds: alert.assoc_ticker_ids ?? []
        };
    } catch ( e: any ) {
        logger.error( `[ trade-alerts-sync-coordinator ] Failed to normalize trade alert '${ alert.id }':`, e );
        return undefined;
    }
}
